import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useParams } from "react-router-dom";
import {
  confirmToast,
  images,
  notifyDanger,
  notifySuccess,
} from "../../actions/customFn";
import axios from "../../api/axios";


const ModuleReport = ({ id }) => {

  const { pathname } = useLocation();
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState(null);

  useEffect(()=>{
    if(!id) return;
    getModuleReport();
  },[id])

  async function getModuleReport() {
    try {
      setLoading(true);
      const url = `/dashboard-data/get-batch-report`;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("oeson_auth")}`
        }
      };
      const data = {
        batchId: id,
      }
      const response = await axios.post(url, data, config);
      console.log(response);
      if (response.status === 200) {
        notifySuccess("Data received")
        setReportData(response.data.data);
      }
    } catch (error) {
      console.log(error);
      notifyDanger(error.message);
    } finally {
      setLoading(false);
    }
  }
  console.log("report data", reportData)

  return (
    <div className="module_student_container">
      <div className="module_student_table scrollbar-template">
        <p>Hello World!</p>
      </div>
    </div>
  );
};

export default ModuleReport;
